import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface DownloadProgress {
  currentPage: number;
  totalPages: number;
  membersCount: number;
  stage: 'fetching' | 'generating' | 'streaming' | null;
  /** Bytes received so far (for backend streaming export) */
  bytesLoaded?: number;
}

interface DownloadProgressContextType {
  downloadProgress: DownloadProgress | null;
  setDownloadProgress: (progress: DownloadProgress | null) => void;
  isDownloading: boolean;
  setIsDownloading: (isDownloading: boolean) => void;
  downloadInProgressRef: React.MutableRefObject<boolean>;
}

const DownloadProgressContext = createContext<DownloadProgressContextType | undefined>(undefined);

export const DownloadProgressProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [downloadProgress, setDownloadProgress] = useState<DownloadProgress | null>(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const downloadInProgressRef = React.useRef(false);

  return (
    <DownloadProgressContext.Provider
      value={{
        downloadProgress,
        setDownloadProgress,
        isDownloading,
        setIsDownloading,
        downloadInProgressRef,
      }}
    >
      {children}
    </DownloadProgressContext.Provider>
  );
};

export const useDownloadProgress = () => {
  const context = useContext(DownloadProgressContext);
  if (context === undefined) {
    throw new Error('useDownloadProgress must be used within a DownloadProgressProvider');
  }
  return context;
};
